module.exports = __webpack_public_path__ + "d2e1fc4bb78f86e15702b9ce1c5ad558.png";